import client from './_client'
import store from '../../store'
import verifyUser from '../interceptor'

const API_TOKEN = process.env.VUE_APP_API_TOKEN

client.interceptors.response.use(
  response => {
    return response
  },
  async error => {
    if (error.response?.status === 403) {
      const authToken = store.getters['auth/authToken']
      await verifyUser(authToken)
    }
    return Promise.reject(error)
  }
)
export default {
  login(data) {
    return client({
      method: 'POST',
      url: 'api/v1/auth/login/local',
      headers: {
        'api-token': API_TOKEN
      },
      data
    })
  },

  loginWithToken(token) {
    return client({
      method: 'get',
      url: `api/v1/users/profile`,
      headers: {
        'auth-token': token,
        'api-token': API_TOKEN
      }
    })
  },

  forgotPassword(data) {
    return client({
      method: 'POST',
      url: `api/v1/auth/passwords/reset/request`,
      headers: {
        'api-token': API_TOKEN
      },
      data
    })
  },

  logout() {
    return client({
      method: 'POST',
      url: 'api/v1/users/logout',
      headers: {
        'api-token': API_TOKEN,
        'auth-token': store.getters['auth/authToken']
      }
    })
  }
}
